import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { COOKIES_REQUIRED_PATH } from '~constants';

import { ResetCodeIsValidGuard } from './guards/reset-code-is-valid.guard';
import { AuthCallbackPage } from './pages/auth-callback/auth-callback.page';
import { CookiesRequiredPage } from './pages/cookies-required/cookies-required.page';
import { ForgottenPasswordPage } from './pages/forgotten-password/forgotten-password.page';
import { LoginPage } from './pages/login/login.page';
import { LogoutPage } from './pages/logout/logout.page';
import { ResetPasswordPage } from './pages/reset-password/reset-password.page';

const routes: Routes = [
  {
    path: 'logout',
    component: LogoutPage,
  },
  {
    path: 'forgotten-password',
    component: ForgottenPasswordPage,
  },
  {
    path: 'expired-link',
    component: ForgottenPasswordPage,
    data: {
      expiredLink: true,
    },
  },
  {
    path: 'reset-password',
    component: ResetPasswordPage,
    canActivate: [ResetCodeIsValidGuard],
  },
  {
    path: 'first-login',
    component: ResetPasswordPage,
    canActivate: [ResetCodeIsValidGuard],
    data: {
      firstLogin: true,
    },
  },
  {
    path: 'login',
    component: LoginPage,
  },
  {
    path: COOKIES_REQUIRED_PATH,
    component: CookiesRequiredPage,
  },
  // Doit rester AVANT le '**' : sinon le code d'autorisation serait avalé par la redirection.
  // Le chemin est celui enregistré comme `redirect-uri` du client `portail`, et la correspondance
  // est exacte côté serveur — le renommer ici demande de le renommer là-bas.
  {
    path: 'auth/callback',
    component: AuthCallbackPage,
  },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
